import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core';
const _ = require('lodash');
@Injectable()

export class RefreshSharedService {
  @Output() fire: EventEmitter<any> = new EventEmitter();
  @Output() dataChangeObserver: EventEmitter<any> = new EventEmitter();

  private arrData: Array<any> = [];
  private value: any;
  private refreshModel = {
        triggeredBy: '',
        target: '',
        loadedComponent: '',
        detailPageIDName: '',
        shouldReloadInventoryTree: false
  }


    constructor() {
        console.log('Refresh shared service started');
    }

    resetParam() {
    }

    setParam(jsonObject: any) {
        console.log ("Refresh Shared Service SetParam",jsonObject);
        if (!jsonObject) {
            return;
        }
        let model = this.refreshModel;
        model.triggeredBy = (jsonObject.triggeredBy) ? jsonObject.triggeredBy : model.triggeredBy;
        model.target = (jsonObject.target) ? jsonObject.target : model.target;
        model.loadedComponent = (jsonObject.loadedComponent) ? jsonObject.loadedComponent : model.loadedComponent;
        model.detailPageIDName = (jsonObject.detailPageIDName) ? jsonObject.detailPageIDName : model.detailPageIDName;
        model.shouldReloadInventoryTree = (jsonObject.shouldReloadInventoryTree) ? jsonObject.shouldReloadInventoryTree : model.shouldReloadInventoryTree;
    }

    refresh(triggeredBy: string = 'refreshIcon') {
        this.refreshModel.triggeredBy = triggeredBy;
        console.log ("Refresh initiated", this.refreshModel);
        this.fire.emit(
            this.refreshModel
        );
    }

    getParam() {
        return this.refreshModel;
    }

    getRefreshParam() {
        return this.fire;
    }


    shouldRefreshPage(jobs) {
        let currentObject = this.refreshModel;
        let crudClassNames = [
            'DirectConnect',
            'DirectConnectDetail',
            'Organization',
            'Vdc',
            'Vapp',
            'Vm',
            'OrgVdcNetworks',
            'OrgVdcNetworkDetail',
            'Gateways',
            'HybridDMZLanding'
        ];

        if (!currentObject.loadedComponent) {
            return false;
        }

        if (crudClassNames.indexOf(currentObject.loadedComponent) === -1) {
            return false;
        }

        for (let job of jobs) {
            console.log ("Job is ", job);

            if (!job.isDone) {
                continue;
            }

            // HDMZ page
            if (currentObject.loadedComponent === 'HybridDMZLanding') {
                if (job.jobType === 'HybridDMZServiceJob') {
                    return true;
                }
            }

            if (job.didFail) {
                continue;
            }

            if (job.workflowType === 'deleteOrganization' || job.workflowType === 'deleteOrganizationVdc') {
                 this.refreshModel.detailPageIDName = '';
                 this.refreshModel.target = 'delete'
                    return true;
            }

            // Compute Jobs
            if (currentObject.loadedComponent === 'Organization' ||
                currentObject.loadedComponent === 'Vdc' ||
                currentObject.loadedComponent === 'Vapp' ||
                currentObject.loadedComponent === 'Vm') {
                if (job.workflowType === 'createOrganization' ||
                    job.workflowType === 'updateOrganization' ||
                    job.workflowType === 'deleteOrganization' ||
                    job.workflowType === 'createOrganizationVdc' ||
                    job.workflowType === 'updateOrganizationVdc' ||
                    job.workflowType === 'deleteOrganizationVdc' ||
                    job.workflowType === 'updateOrganizationVdcStorageProfiles') {
                        return true;
                }
            }

            // DC Listing page. No need to check ID
            if (currentObject.loadedComponent === 'DirectConnect') {
                if (job.jobType === 'DirectConnectJob') {
                    return true;
                }
            }

            //DC details page.
            if (currentObject.loadedComponent === 'DirectConnectDetail') {
                if (job.jobType === 'DirectConnectJob') {
                    return true;
                }
            }

            // Gateways
            if (currentObject.loadedComponent === 'Gateways') {
                if (job.workflowType === 'createEdgeGateway' ||
                    job.workflowType === 'updateEdgeGateway' ||
                    job.workflowType === 'deleteEdgeGateway') {
                    return true;
                }
            }
        }
        return false;

    }

}



// WEBPACK FOOTER //
// ./src/app/refresh-shared-service.ts